import * as React from 'react'
import {  Paper, Box, Tab, Tabs, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, withStyles, Theme, createStyles } from '@material-ui/core'
import { useHistory, useParams } from 'react-router';
import {  listCoachInitialInterviews, listCoachCoachings } from '../../utils/api';
import useRefresh from '../../hooks/useRefresh';
import TabPanel from '../../components/TabPanel';
import { useQuery } from 'react-query';
import moment from 'moment';

const CoachHome = () => {
    const history = useHistory()
    const [tabIndex, setTabIndex] = React.useState(0)
    const { type } = useParams<{ type: string | undefined }>()
    const [status] = React.useState<undefined | 'create' | 'finish'>()

    const initialInterviewResult = useQuery<{ list: InitialInterview[] }>([status], listCoachInitialInterviews)
    const { data: coachingsResult } = useQuery<{ list: Coaching[] }>('listCoachCoachings', listCoachCoachings)


    const toInterview = (clientId: number, id: number) => () => {
        history.push(`/coach/client/${clientId}/initialinterview/${id}`)
    }

    const toCoaching = (clientId: number, id: number) => () => {
        history.push(`/coach/client/${clientId}/coaching/${id}`)
    }

    const toClient = (clientId: number) => () => {
        history.push(`/coach/client/${clientId}`)
    }

    useRefresh(() => {
        initialInterviewResult.refetch()
    })

    React.useEffect(() => {
        if (!type) {
            setTabIndex(0);
        } else if (type === 'oneonone') {
            setTabIndex(1);
        } else if (type === 'group') {
            setTabIndex(2);
        }
    }, [type])

    const handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        if (newValue === 0) {
            history.replace('/coach/home')
        } else if (newValue === 1) {
            history.replace('/coach/home/oneonone')
        } else if (newValue === 2) {
            history.replace('/coach/home/group')
        }
        setTabIndex(newValue);
    };

    const PlanTab = withStyles((theme: Theme) =>
        createStyles({
            root: {
                textAlign: 'left',
                color: '#333',
                '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText
                },

            },
            selected: {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        })
    )(Tab)

    return <div>
        <Box>
            <Paper>
                <Tabs variant="fullWidth" value={tabIndex} onChange={handleTabIndexChange}>
                    <PlanTab style={{ padding: '12px 0' }} label="首次约谈" />
                    <PlanTab style={{ padding: '12px 0' }} label="1对1教练" />
                    <PlanTab style={{ padding: '12px 0' }} label="团体教练" />
                </Tabs>
                <TabPanel value={tabIndex} index={0}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>来访者姓名</TableCell>
                                    <TableCell>来访者手机</TableCell>
                                    <TableCell>任务名称</TableCell>
                                    <TableCell>预约处理时间</TableCell>
                                    <TableCell>任务状态</TableCell>
                                    <TableCell>操作</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {initialInterviewResult.data?.list.map((interview, index) => <TableRow key={interview.id}>
                                    <TableCell><Button size="small" variant="text" style={{textTransform: 'none'}} onClick={toClient(interview.client_id)}>{interview.name}</Button></TableCell>
                                    <TableCell>{interview.mobile}</TableCell>
                                    <TableCell>首次约谈</TableCell>
                                    <TableCell>{moment(interview.appointment_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                                    <TableCell>{interview.status === 'finish' ? '已完成' : '未完成'}</TableCell>
                                    <TableCell>
                                        <Button size="small" onClick={toInterview(interview.client_id, interview.id)}>{interview.status === 'finish' ? '查看' : '处理'}</Button>
                                    </TableCell>
                                </TableRow>)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>来访者姓名</TableCell>
                                    <TableCell>来访者手机</TableCell>
                                    <TableCell>训练进度</TableCell>
                                    <TableCell>操作</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {coachingsResult?.list.map((coaching, index) => <TableRow key={coaching.id}>
                                    <TableCell><Button size="small" style={{textTransform: 'none'}} variant="text" onClick={toClient(coaching.client_id)}>{coaching.name}</Button></TableCell>
                                    <TableCell>{coaching.mobile}</TableCell>
                                    <TableCell>{`${coaching.currentLevel}/${coaching.number_of_times}`}次训练</TableCell>
                                    <TableCell>
                                        <Button size="small" onClick={toCoaching(coaching.client_id, coaching.id)}>处理</Button>
                                    </TableCell>
                                </TableRow>)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
            </Paper>
        </Box>
    </div>
}

export default CoachHome